const blocks = document.querySelectorAll('section.accordions');

if(blocks) {
    blocks.forEach(function(block, index) {
        const accordions = block.querySelectorAll('.accordion');
        const moreBtn = block.querySelector('.more-btn');
        const search = block.querySelector('.search-wrapper');

        if(accordions) {
            accordions.forEach(function(accordion, index) {
                accordion.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    let parent = accordion.parentNode;
                    if(!parent.classList.contains('open')) {
                        parent.classList.add('open');
                        accordion.setAttribute('aria-expanded', 'true');
                    }
                    else {
                        parent.classList.remove('open');
                        accordion.setAttribute('aria-expanded', 'false');
                    }
                });
            });
        }

        if(moreBtn) {
            moreBtn.addEventListener('click', function(e) {
                if(!this.classList.contains('show-less')) {
                    this.classList.add('show-less');
                    this.querySelector('span').innerText = 'Show less';
                    accordions.forEach(function(accordion, index) {
                        accordion.parentElement.classList.add('show');
                    });
                }
                else {
                    this.classList.remove('show-less');
                    this.querySelector('span').innerText = this.getAttribute('data-text');
                    accordions.forEach(function(accordion, index) {
                        accordion.parentElement.classList.remove('show');
                        if(index < 4) {
                            accordion.parentElement.classList.add('show');
                        }
                    });

                    // Scroll to top of block if it has an ID
                    if(block.id) {
                        block.scrollIntoView({ behavior: 'smooth', block: 'start' });
                    }
                }

            });
        }

        if(search) {
            const searchInput = search.querySelector('#search-input');
            const searchButton = search.querySelector('.search-submit-button');
            const noResultsMessage = block.querySelector('.no-results-message');

            function performSearch() {
                const searchTerm = searchInput.value.toLowerCase().trim();

                // If search is cleared, reset to initial state
                if(searchTerm === '') {
                    accordions.forEach(function(accordion, index) {
                        const parent = accordion.parentElement;
                        parent.classList.remove('hidden-by-search');
                        parent.classList.remove('open');
                        accordion.setAttribute('aria-expanded', 'false');

                        // Show only first 4 accordions initially (unless "more" button is active)
                        if(moreBtn && !moreBtn.classList.contains('show-less')) {
                            if(index < 4) {
                                parent.classList.add('show');
                            } else {
                                parent.classList.remove('show');
                            }
                        } else {
                            parent.classList.add('show');
                        }
                    });

                    if(moreBtn) {
                        moreBtn.style.display = '';
                    }

                    if(noResultsMessage) {
                        noResultsMessage.classList.add('hidden');
                    }
                    return;
                }

                // Perform search
                let resultsFound = 0;
                accordions.forEach(function(accordion) {
                    const parent = accordion.parentElement;
                    const titleElement = accordion.querySelector('.faq-title');
                    const contentElement = parent.querySelector('.expandable-content .text-content');

                    if(!titleElement || !contentElement) return;

                    const title = titleElement.textContent.toLowerCase();
                    const content = contentElement.textContent.toLowerCase();

                    // Check if search term matches title or content
                    if(title.includes(searchTerm) || content.includes(searchTerm)) {
                        parent.classList.add('show');
                        parent.classList.remove('hidden-by-search');
                        resultsFound++;
                    } else {
                        parent.classList.remove('show');
                        parent.classList.add('hidden-by-search');
                        parent.classList.remove('open');
                        accordion.setAttribute('aria-expanded', 'false');
                    }
                });

                // Show/hide no results message
                if(noResultsMessage) {
                    if(resultsFound === 0) {
                        noResultsMessage.classList.remove('hidden');
                    } else {
                        noResultsMessage.classList.add('hidden');
                    }
                }

                // Hide "more" button during active search
                if(moreBtn) {
                    moreBtn.style.display = 'none';
                }
            }

            // Trigger search on Enter key
            searchInput.addEventListener('keypress', function(e) {
                if(e.key === 'Enter') {
                    e.preventDefault();
                    performSearch();
                }
            });

            // Trigger search on button click
            if(searchButton) {
                searchButton.addEventListener('click', function(e) {
                    e.preventDefault();
                    performSearch();
                });
            }

            // Trigger reset when input is cleared (manually deleted or clear button clicked)
            searchInput.addEventListener('input', function() {
                if(this.value.trim() === '') {
                    performSearch();
                }
            });
        }

    });
}
